// extracted by mini-css-extract-plugin
export default {"main":"Error_main__VT9go","li_box":"Error_li_box__rPamN"};